import { createAction } from "@reduxjs/toolkit";
import {
  signInActionTypes,
  signInMetamask,
  signInGoogle,
  signInTwitch,
  signInTwitter,
  toggleSignInModalType,
} from "./actionTypes";

export const signIn = createAction(signInActionTypes.request, (payload) => ({
  payload,
}));

export const signInSuccess = createAction(
  signInActionTypes.success,
  (payload) => ({ payload }),
);

export const signInFailure = createAction(
  signInActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const signInWithMetamask = createAction(
  signInMetamask.request,
  (payload) => ({ payload }),
);

export const signInWithGoogle = createAction(
  signInGoogle.request,
  (payload) => ({ payload }),
);

export const signInWithTwitch = createAction(
  signInTwitch.request,
  (payload) => ({ payload }),
);

export const signInWithTwitter = createAction(
  signInTwitter.request,
  (payload) => ({ payload }),
);

export const signInReset = createAction(signInActionTypes.reset);

export const toggleSignInModal = createAction(toggleSignInModalType);
